var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "spa-reservation-heading container" }, [
    _c("div", { staticClass: "spa-reservation-heading__top" }, [
      _c(
        "a",
        {
          staticClass: "spa-reservation-heading__back-link",
          attrs: {
            href:
              "/" +
              _vm.lang +
              _vm.spaReservationPage +
              "#/spa-soft?hotelCode=" +
              _vm.reservationDetailsData.hotelCode,
          },
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.tc(
                  "spaSoft.reservationdetails.reserveAnotherSpaAppointmentCta"
                )
              ) +
              "\n    "
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "spa-reservation-heading__main" }, [
      _c("h1", { staticClass: "spa-reservation-heading__title" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm.tc("spaSoft.reservationdetails.reservationTitle")) +
            "\n    "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "spa-reservation-heading__status-actions" }, [
        _c(
          "span",
          {
            staticClass: "spa-reservation-heading__badge",
            class:
              "--" + (_vm.isReservationCancelled ? "cancelled" : "confirmed"),
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.isReservationCancelled
                    ? _vm.tc(
                        "spaSoft.reservationdetails.reservationStatusCancelled"
                      )
                    : _vm.tc(
                        "spaSoft.reservationdetails.reservationStatusConfirmed"
                      )
                ) +
                "\n      "
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }